function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
const statusesApi = buildService('/claim_groups/{id}/technical_narrative_upload_status', {
  only: ['all', 'base']
}, {
  only: ['postFormData']
});
const technicalNarrativesApi = buildService('/claim_groups/{id}/technical_narrative_imports', {
  only: ['all', 'base']
}, {
  only: ['postFormData']
});
const importNarrativeService = {
  create(claimGroupId, formData) {
    return fetch("/api/claim_groups/".concat(claimGroupId, "/technical_narrative_imports/"), _objectSpread(_objectSpread({}, request.post), {}, {
      headers: {
        'Accept': 'application/json, text/plain, */*'
      },
      body: formData
    }));
  }
};
const useFetchTechnicalNarrativeImportStatusWithInterval = _ref => {
  let {
    claimGroupId,
    setLoading
  } = _ref;
  const {
    interval,
    setInterval,
    stateVar: importStatus,
    setStateVar: setImportStatus
  } = serviceMethods.useFetchWithInterval({
    api: statusesApi,
    callback: useCallback(async () => await statusesApi.all(claimGroupId), [claimGroupId]),
    setLoading
  });
  return {
    importStatus,
    setImportStatus,
    interval,
    setInterval
  };
};
const useUploadTechnicalNarrative = _ref2 => {
  let {
    claimGroupId,
    setLoading,
    handleToaster,
    onSuccess
  } = _ref2;
  const {
    t
  } = useTranslation();
  //accepts an object with the formDataJson field and any other fields.
  const postFormData = serviceMethods.usePostFormDataFileFromEvent({
    setLoading,
    onSuccess,
    handleToaster,
    callback: useCallback(async _ref3 => {
      let {
        formData
      } = _ref3;
      const result = await technicalNarrativesApi.postFormData(claimGroupId, formData);
      handleToaster('success', t('upload_is_in_progress'));
      return result;
    }, [claimGroupId, handleToaster, t])
  });
  return postFormData;
};
const claimGroupTechnicalNarrativeService = _objectSpread(_objectSpread({}, importNarrativeService), {}, {
  useFetchTechnicalNarrativeImportStatusWithInterval,
  useUploadTechnicalNarrative
});
export default claimGroupTechnicalNarrativeService;